/**
 * item property가 계속 늘어남에 따라
 * 아이템 주문 제한 관련 기능 추가한 시점을 기준으로
 * 추가적인 property는 itemOptProperty 객체에 담는 방식으로 변경,
 * 프론트에서는 이 itemOptProperty를 평탄화 하여 진행
 */
export function flattenShopItemProperty(item, override = false) {
  const out = {}
  for (const k in item) {
    if (k !== 'itemOptProperty' && Object.prototype.hasOwnProperty.call(item, k)) {
      out[k] = item[k]
    }
  }
  const opt = item && item.itemOptProperty
  if (opt && typeof opt === 'object') {
    for (const ok in opt) {
      if (!Object.prototype.hasOwnProperty.call(opt, ok)) continue
      if (override || !(ok in out)) out[ok] = opt[ok]
    }
  }
  return out
}
